import * as Icon from '../assets/icons';

import useMediaQuery from '../hooks/media';
import './whatsapp.css';

const WhatsApp = () => {
  const {isXSmall, isMedium} = useMediaQuery();

  return (
    <div className="whatsapp">
      <a
        className="whatsapp__link"
        href="https://wa.me/905559725285"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp">
        <div>
          <Icon.Whatsapp
            className="whatsapp__icon"
            size={isXSmall ? 40 : isMedium ? 50 : 60}
          />
        </div>
      </a>
    </div>
  );
};

export default WhatsApp;
